import React from 'react';
import {
  Button
} from '@chakra-ui/react';
import { colors } from '../../../assets/colors';

interface AppButtonProps {
  text: string;
  onClick: () => void;
  color?: string;
  isDisabled?: boolean;
}

const AppButton: React.FC<AppButtonProps> = ({ text, onClick, color, isDisabled}) => {
  const buttonColor = color ? color : colors.primary;
  const buttonDisabled = isDisabled ? isDisabled : false;

  return (
    <>
    <Button
      rounded={'none'}
      w={'full'}
      mt={8}
      size={'lg'}
      py={'7'}
      bg={buttonColor}
      borderRadius={'full'}
      color={'white'}
      _hover={{
        transform: 'translateY(2px)',
        boxShadow: 'lg',
      }}
      onClick={() => onClick()}
      isDisabled={buttonDisabled}
    >
      {text}
    </Button>
    </>
    );
};

export default AppButton;